import { render, staticRenderFns } from "./OccurrenceObservationTable.vue?vue&type=template&id=a4194aa6&"
import script from "./OccurrenceObservationTable.vue?vue&type=script&lang=js&"
export * from "./OccurrenceObservationTable.vue?vue&type=script&lang=js&"
import style0 from "./OccurrenceObservationTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VDataTable})
